import React from "react";
import { useI18n } from "../context/I18nContext";

// Seletor de idioma em duas variantes:
//   "compacto" - dois botoes curtos, cabe na sidebar escura do dashboard;
//   "completo" - lista com o nome do idioma por extenso, para Configuracoes,
//                que e onde a pessoa procura por uma preferencia.
// O rotulo de cada idioma aparece SEMPRE no proprio idioma ("Portugues",
// "English"), nunca traduzido: quem esta perdido num idioma que nao fala
// precisa reconhecer o seu na lista.
const LanguageSwitcher = ({ variante = "compacto", className = "" }) => {
  const { idioma, setIdioma, idiomas, t } = useI18n();

  if (variante === "completo") {
    return (
      <div className={`grid gap-2 sm:grid-cols-2 ${className}`}>
        {idiomas.map((def) => {
          const ativo = def.codigo === idioma;
          return (
            <button
              key={def.codigo}
              type="button"
              onClick={() => setIdioma(def.codigo)}
              aria-pressed={ativo}
              lang={def.htmlLang}
              className={`flex items-center justify-between px-4 h-12 rounded-xl border transition-all text-left ${
                ativo
                  ? "border-whatsapp bg-whatsapp/5 text-gray-900"
                  : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"
              }`}
            >
              <span className="flex items-center gap-3">
                <span className="text-xs font-bold text-gray-400 w-6">{def.bandeira}</span>
                <span className="text-sm font-medium">{def.rotulo}</span>
              </span>
              {ativo && (
                <svg className="w-5 h-5 text-whatsapp" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`flex gap-1 ${className}`} title={t("common.language")}>
      {idiomas.map((def) => {
        const ativo = def.codigo === idioma;
        return (
          <button
            key={def.codigo}
            type="button"
            onClick={() => setIdioma(def.codigo)}
            aria-pressed={ativo}
            lang={def.htmlLang}
            title={def.rotulo}
            className={`flex-1 h-8 rounded-md text-xs font-semibold transition-all ${
              ativo
                ? "bg-whatsapp text-white"
                : "text-gray-400 hover:bg-gray-800 hover:text-white"
            }`}
          >
            {def.bandeira}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
